import { FormControl, FormGroup } from '@angular/forms';
import { Nillable } from '@web/utils';

export type AdminValidationSettingsFormControls = {
  nipBlackList: FormControl<Nillable<string>>;
};

export class AdminValidationSettingsFormData {
  public constructor(
    private readonly data: {
      nipBlackList: string[];
    },
  ) {}

  public get nipBlackList(): string[] {
    return this.data.nipBlackList;
  }
}

/* prettier-ignore */
export type AdminValidationSettingsFormGroup = FormGroup<AdminValidationSettingsFormControls>;
